import { Typography, Label, TickIcon as Tick } from "@packages/ds";
import styled from "styled-components";

import ComponentTitle from "src/root/pages/components/Title";
import CustomBackground from "Vendor_resources/images/custom_background_image.png";
import CustomMainLogo from "Vendor_resources/images/custom_main_logo.svg";

export const LeftLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${CustomBackground});
  background-color: ${"var(--background-vendor-color-section-background-color,var(--section-ebony-background-color,var(--ebony)))"};
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: 940px) {
    display: none;
  }

  color: var(
    --auth-left-panel-video-section-color,
    var(--section-night-color, var(--night))
  );
`;

export const VideoLeftLayout = styled(LeftLayout)`
  background-color: var(--theme-neutral-1000);
  color: var(--theme-neutral-0);
`;

export const VideoBodyText = styled(Typography.BodyText)`
  background-color: var(--theme-neutral-1000);
  color: var(--mode-text-neutral-inverse-strong);
  line-height: 20px;
`;

export const VideoBodyTitle = styled(VideoBodyText)`
  margin-bottom: 16px;
`;
export const MainImageContainer = styled.div`
  height: 200px;
  width: 300px;
  margin-top: 164px;
  background-image: url(${CustomMainLogo});
  background-position: 0 0;
  background-size: contain;
  background-repeat: no-repeat;
`;

export const Video = styled.div`
  width: calc(100% - 64px);
  margin-top: 40px;

  .video {
    aspect-ratio: 16 / 9;
    width: 100%;
  }
`;
export const Title = styled.p`
  text-align: center;
  font-size: 32px;
  font-style: normal;
  font-weight: 900;
  line-height: 33px;
`;

export const Description = styled.p`
  text-align: center;
  font-family: Open Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
`;

export const FooterText = styled.p`
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 33px;
`;

export const TextTitleContainer = styled.div``;

export const TextDescriptionContainer = styled.div`
  margin-top: 20px;
  max-width: 424px;
`;

export const FooterContainer = styled.div`
  margin-top: 175px;
`;

export const ButtonWrapper = styled.div`
  margin-top: 64px;
`;

export const VideoTextWrapper = styled.div`
  margin: 40px 40px 0 40px;
`;

export const VideoTitle = styled.h1`
  color: var(--mode-text-neutral-inverse-strong);

  font-style: normal;
  font-weight: 900;
  font-size: 32px;
  line-height: ${props => props.lineHeight || "40px"};
  margin: 0;

  &::first-letter {
    text-transform: uppercase;
  }

  @media only screen and (max-width: 940px) {
    font-size: 20px;
  }
`;

export const VideoTitleContainer = styled.div`
  box-sizing: border-box;

  padding: 40px 40px 0 40px;
  align-self: flex-start;
  width: 100%;
`;

export const BulletsTextWrapper = styled.div`
  box-sizing: border-box;

  padding: 40px 40px 0 30px;
  align-self: flex-start;
  width: 100%;
`;

export const ListWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const BulletBodyText = styled(Typography.BodyText)`
  background-color: var(--theme-neutral-1000);
  color: var(--mode-text-neutral-inverse-strong);
  line-height: 20px;
  margin-left: 16px;
`;

export const BulletTick = styled(Tick)`
  fill: var(--color-platform-pink-600);
`;
